CSSPlugin.defaultTransformPerspective = 600;
var toggleMenu = $('.main-nav__toggle');
var toggleCollapse = $('.main-nav__collapse');
var toggleDisplay = $('.display');
var menuLinks = $('.main-nav__link');
transitionAnimation = new TimelineMax({ paused: true, reversed: true });
      
transitionAnimation
  // .set($el,{opacity:0, visibility:"visible"})
  // .to($el, 0.5,{opacity:1, ease:Power2.easeOut})
  // .from($(".navbar, .scroll-navbar"),1,{y:-96, ease:Expo.easeInOut}, 0.5)
  // .to(toggleDisplay,0.4,{opacity:0, ease:Power2.easeOut})
  .to(toggleCollapse,0.5,{x:0, ease:Power2.easeOut})
  .staggerFrom(menuLinks,0.4,{opacity:0, x:60, ease:Expo.easeOut}, 0.05,"-=0.4");

toggleMenu.on('click', function() {
  transitionAnimation.reversed() ? transitionAnimation.play() : transitionAnimation.reverse();
  $(this).toggleClass('open');
});

menuLinks.on('click', function() {
  transitionAnimation.reversed() ? transitionAnimation.play() : transitionAnimation.reverse();
  toggleMenu.toggleClass('open');
});